import { createFileRoute } from '@tanstack/react-router'
import { redirectCredentialEntry } from '#start/server/credential-redirect'
export const Route = createFileRoute('/_app/account_/credentials')({
	staticData: {
		navigation: { rail: 'workspace', item: 'credentials' },
	},
	validateSearch: (search: Record<string, unknown>) => search,
	beforeLoad: ({ location }) =>
		redirectCredentialEntry({ data: location.pathname + location.searchStr }),
})
